import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-standard-tent',
  templateUrl: './standard-tent.component.html',
  styleUrls: ['./standard-tent.component.css']
})
export class StandardTentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
